import { FX_SOURCES } from '../wire/specialists/fx.js';
const KEYS = new Set(['bynPerUsd', 'bynPerEur', 'asOf', 'source']);
const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME_RE = /^(\d{4}-\d{2}-\d{2})T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/;
const fail = (error) => ({ ok: false, error });
const isRate = (v) => typeof v === 'number' && Number.isFinite(v) && v > 0;
const isFxSource = (v) => typeof v === 'string' && FX_SOURCES.includes(v);
/** A real calendar day: `2026-13-40` and `2026-02-30` are rejected. */
function isCalendarDate(value) {
    const m = DATE_RE.exec(value);
    if (!m)
        return false;
    const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
    const date = new Date(Date.UTC(y, mo - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === mo - 1 && date.getUTCDate() === d;
}
/** `YYYY-MM-DD` or a full ISO timestamp with a zone (`Z` / `±HH:MM`). */
function isAsOf(v) {
    if (typeof v !== 'string')
        return false;
    if (DATE_RE.test(v))
        return isCalendarDate(v);
    const m = TIME_RE.exec(v);
    return m !== null && isCalendarDate(m[1] ?? '') && Number.isFinite(Date.parse(v));
}
export function parseFxSnapshot(raw) {
    if (raw === null)
        return { ok: true, value: null };
    if (typeof raw !== 'object' || Array.isArray(raw))
        return fail('fx_not_object');
    const body = raw;
    for (const key of Object.keys(body))
        if (!KEYS.has(key))
            return fail(`fx_unknown_key:${key}`);
    if (!isRate(body.bynPerUsd))
        return fail('fx_byn_per_usd_invalid');
    if ('bynPerEur' in body && !isRate(body.bynPerEur))
        return fail('fx_byn_per_eur_invalid');
    if (!isAsOf(body.asOf))
        return fail('fx_as_of_invalid');
    if (!isFxSource(body.source))
        return fail('fx_source_invalid');
    const value = { bynPerUsd: body.bynPerUsd, asOf: body.asOf, source: body.source };
    if (isRate(body.bynPerEur))
        value.bynPerEur = body.bynPerEur;
    return { ok: true, value };
}
//# sourceMappingURL=fx-snapshot.js.map